import { render, staticRenderFns } from "./PDNMainPage.vue?vue&type=template&id=42cc665b&scoped=true&"
import script from "./PDNMainPage.vue?vue&type=script&lang=js&"
export * from "./PDNMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cc665b",
  null
  
)

export default component.exports